import { useEffect, useState } from 'react'

const MD_BREAKPOINT = 768 // matches Tailwind's md: breakpoint

/**
 * Returns true when the viewport is below the md breakpoint (< 768px).
 * Reactive — updates on resize via MediaQueryList.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth < MD_BREAKPOINT : false))

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MD_BREAKPOINT - 1}px)`)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return isMobile
}
